export default "__VITE_ASSET__VRk8gfKd__"